import {TheCryptGameConfig} from "../../TheCryptGameConfig";
import {TheCrypt} from "../../TheCrypt";
import {TimelineLite} from "gsap";
import Spine = PIXI.spine.Spine;
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {TheCryptSoundManager} from "../../sound/TheCryptSoundManager";
import {TheCryptSoundConfig} from "../../configs/TheCryptSoundConfig";
import {TheCryptFontConfig} from "../../configs/TheCryptFontConfig";
import {BitmapText} from "pixi.js";

export class SpriteCollector extends PIXI.Sprite {
    //protected _bars: CollectorBar;
    protected _spine: Spine | null;
    protected _id: number;
    protected _step: number;
    protected _isActive: boolean = false;
    protected _overlay: BitmapText;
    protected _barNum: number;

    constructor(id: number, container: PIXI.Container) {
        super();
        this._id = id;
        this.anchor.set(0, 0);
        this.name = `SpriteCollector-M${this._id}`;
        this._overlay = new BitmapText("", TheCryptFontConfig.M1_MULTIPLIER_STYLE);
        this._overlay.alpha = 0;
        this._overlay.position.set(0, 14.5);
        this._isActive = false;
        this._step = -1;
        this._barNum = (id === 1 ? TheCryptGameConfig.M1CollectorLevels : TheCryptGameConfig.MSymbolCollectorLevels);
        this.visible = false;
        container.addChild(this);
        //this._bars = (id === 1?new CollectorBarM1(this, this._id, 3):new CollectorBar(this, this._id, 4));
    }

    private destroySpine(): void {
        if (this._spine) {
            this._spine.destroy();
            this._spine = null;
        }
    }

    public reset() {
        //this._bars.reset();
        this._overlay.alpha = 0;
        this._isActive = false;
        this._step = -1;
        this.visible = false;
        this.destroySpine();
    }

    public fullyCharged():TimelineLite {
        this.isActive = false;
        this._step = 5;
        return new TimelineLite().add([
            new SpineTween(this._spine!, 0, "wild"),
            ()=>{TheCryptSoundManager.playSound(TheCryptSoundConfig.METER_TO_WILD);}
            ]).add(()=>{this._spine?.state.setAnimation(0, "wild", true);});
    }

    public upgrade():TimelineLite {
        this._step++;
        if (this._step > this._barNum) {
            debugger;
        }

        const tl:TimelineLite = new TimelineLite();
        if(!(this._step === 0 || this._step === 4)){
            tl.add([
                ()=>{TheCryptSoundManager.playSound(TheCryptSoundConfig.METER_LIGHT);},
                new SpineTween(this._spine!, 0, `${this._step}_add`)
            ]);
        }

        tl.add(()=>{this._spine?.state.setAnimation(0, `${this._step}`, true);});

        return tl;
    }

    public show(name:string, isRestore: boolean = false):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        this.visible = true;
        this._step = -1;
        this.destroySpine();
        this._spine = new Spine(TheCrypt.assetLoader.getSpineAsset(name));
        this._step = Math.max(-1, this._step);
        return tl;
    }

    get isFullyCharged(): boolean {
        return this._step === this._barNum && this._isActive;
    }

    get topLevel(): number {
        return this._barNum;
    }


    public set overlayText(value: number) {
    }

    public set isActive(value: boolean) {
        this._isActive = value;
    }

    public get isActive():boolean {
        return this._isActive;
    }

    public get id(): number {
        return this._id;
    }

    public get overlay(): BitmapText {
        return this._overlay;
    }

    public get progress(): number {
        return this._step;
    }

    public get currentHeight(): number {
        return this._isActive ? 136 : 80;
    }
}